import { render } from "./InstallPwaComponent.vue?vue&type=template&id=13c685b2&scoped=true&ts=true"
import script from "./InstallPwaComponent.vue?vue&type=script&lang=ts"
export * from "./InstallPwaComponent.vue?vue&type=script&lang=ts"

import "./InstallPwaComponent.vue?vue&type=style&index=0&id=13c685b2&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c685b2"]])

export default __exports__